module.exports = __webpack_public_path__ + "img/spinner-marker.9bd27519.svg";